import { defineSlotRecipe } from "@chakra-ui/react";

import radioMarkRecipe from "./RadioMark";

const radioGroupSlotRecipe = defineSlotRecipe({
  className: "chakra-radio-group",
  slots: ["root", "item", "label", "itemControl", "itemAddon", "itemIndicator"],
  base: {
    item: {
      fontFamily: "Inter, sans-serif",
      display: "inline-flex",
      alignItems: "center",
      _disabled: {
        cursor: "not-allowed",
        color: "text.soft",
      },
      _hover: {
        cursor: "pointer",
      },
    },
    label: {
      userSelect: "none",
      fontFamily: "Inter, sans-serif",
      textStyle: "body.standard",
      fontWeight: "medium",
      _hover: {
        cursor: "pointer",
      },
      _disabled: {
        color: "text.soft",
      },
    },
    itemControl: radioMarkRecipe.base,
  },
  variants: {
    variant: {
      legacy: {
        item: {
          display: "flex",
          alignItems: "center",
          borderWidth: "1px",
          borderRadius: "12px",
          borderColor: "gray.300",
          color: "gray.900",
          width: "166px",
          height: "56px",
          p: "2",
          mb: "2",
          _focusWithin: {
            boxShadow: "none",
          },
        },
        label: {
          color: "warning.400",
        },
        itemIndicator: {
          ml: "5px",
          height: "15px",
          w: "15px",
          borderWidth: "2px",
          _checked: {
            bg: "#f0a32f",
            color: "#f0a32f",
            borderColor: "white",
            boxShadow: "0 0 0 1px white, 0 0 0 3px #f0a32f",
            borderWidth: "1.5px",
          },
        },
        itemControl: radioMarkRecipe.variants?.variant.legacy,
      },
      outline: {
        label: {
          color: "warning.400",
        },
        itemControl: radioMarkRecipe.variants?.variant.outline,
        _disabled: {
          layerStyle: "disabled",
          cursor: "not-allowed",
          color: "text.soft",
          backgroundColor: "base.400",
        },
      },
    },
    size: {
      sm: {
        item: {
          height: "32px",
          width: "32px",
        },
        itemControl: radioMarkRecipe.variants?.size?.sm,
      },
      lg: {
        item: {
          height: "48px",
          width: "48px",
        },
        itemControl: radioMarkRecipe.variants?.size?.lg,
      },
    },
  },
  defaultVariants: {
    variant: "legacy",
    size: "sm",
  },
});

export default radioGroupSlotRecipe;
